export default __webpack_public_path__ + "static/media/IMG_8794.b5f55a57.jpg";